// CineARt AI — بيانات محاكاة واقعية وأدوات مساعدة
// جاهز للربط لاحقًا بذكاء اصطناعي حقيقي للرؤية والكاميرا والواقع المعزز.

export const SCENE_TYPES = [
  { id: "drama", name: "درامي", emoji: "fa-masks-theater", color: "#c79a4e" },
  { id: "horror", name: "رعب", emoji: "fa-ghost", color: "#5b7cff" },
  { id: "comedy", name: "كوميدي", emoji: "fa-face-laugh", color: "#f0b93a" },
  { id: "action", name: "أكشن", emoji: "fa-fire", color: "#ff6b3d" },
  { id: "romance", name: "رومانسي", emoji: "fa-heart", color: "#ff7d9c" },
  { id: "documentary", name: "وثائقي", emoji: "fa-clapperboard", color: "#7bd88f" },
  { id: "scifi", name: "خيال علمي", emoji: "fa-robot", color: "#4ea8ff" },
  { id: "night", name: "مشهد ليلي", emoji: "fa-moon", color: "#8ea2c9" },
];

// نتائج تحليل محاكاة لكل نوع مشهد
export const SCENE_ANALYSIS = {
  drama: {
    filter: "dramatic-dark",
    readout: {
      "قوة الإضاءة": "متوسطة — إضاءة منخفضة المفتاح (Low-key)",
      "اتجاه الضوء": "جانبي من اليمين بزاوية 45°",
      "الظلال": "عميقة ومتحكم بها تبرز ملامح الوجه",
      "درجة حرارة اللون": "دافئة (≈ 3400K)",
      "موضع الشخصية": "على خط الثلث الأيمن",
      "الخلفية": "معتمة وناعمة (Bokeh) لعزل الشخصية",
      "التوازن": "متوازن مع ثقل بصري نحو اليمين",
      "العمق": "عمق ميدان ضحل يعزل الموضوع",
      "الخطوط القيادية": "خط النظر يقود نحو الشخصية",
      "التكوين": "قاعدة الأثلاث + مساحة سالبة درامية",
      "التباين": "عالٍ نسبيًا بين الضوء والظل",
      "الألوان السائدة": ["#3a2b1c", "#c79a4e", "#1a1410"],
    },
    recs: [
      ["حساسية الضوء ISO", "ISO 400", "لأن الإضاءة منخفضة المفتاح وتحتاج توازنًا بين الضوضاء والتعريض", "اضبط الكاميرا يدويًا على 400 وثبّت التعريض", 92],
      ["فتحة العدسة", "f/2.8", "لعزل الشخصية عن الخلفية بعمق ميدان ضحل", "افتح العدسة إلى f/2.8 وركّز على العين", 90],
      ["سرعة الغالق", "1/50", "لمطابقة معدل 24 إطارًا وإعطاء إحساس سينمائي", "اضبط الغالق على 1/50 ثانية", 95],
      ["عدد الإطارات FPS", "24 FPS", "المعدل السينمائي الكلاسيكي للدراما", "اختر 24 إطارًا في الثانية", 96],
      ["توازن اللون الأبيض", "3400K دافئ", "لتعزيز الإحساس الدرامي الحميمي", "اضبط WB يدويًا على 3400K", 88],
      ["نوع العدسة", "عدسة أساسية (Prime)", "لحدة وعزل أفضل مع فتحة واسعة", "استخدم عدسة ثابتة البؤرة", 85],
      ["البعد البؤري", "50mm", "قريب من رؤية العين ومثالي للوجه", "استخدم 50mm للقطات الوجه", 87],
      ["حجم اللقطة", "لقطة متوسطة قريبة", "لإبراز المشاعر مع بقاء السياق", "أطّر من الصدر حتى أعلى الرأس", 89],
      ["زاوية التصوير", "زاوية منخفضة طفيفة", "لإضفاء هيبة على الشخصية", "اخفض الكاميرا قليلًا تحت مستوى العين", 82],
      ["حركة الكاميرا", "ثابتة أو دوللي بطيء", "للحفاظ على التوتر الدرامي", "استخدم حاملًا ثابتًا أو حركة بطيئة", 84],
      ["اتجاه الإضاءة", "ضوء رئيسي جانبي", "لخلق ظلال معبّرة على الوجه", "ضع المصدر الرئيسي على اليمين 45°", 90],
      ["توزيع العناصر", "قاعدة الأثلاث", "لتكوين متوازن وجذاب", "ضع العين على خط الثلث العلوي", 91],
      ["العمق البصري", "ثلاث طبقات (أمامية/موضوع/خلفية)", "لخلق عمق سينمائي", "أضف عنصرًا أماميًا معتمًا", 80],
      ["الفلتر المناسب", "درامي داكن", "يعزز الظلال والدفء الدرامي", "طبّق فلتر (درامي داكن) بشدة 70%", 93],
    ],
    scores: { overall: 88, composition: 90, lighting: 86, colors: 84, camera: 89 },
    strengths: ["عزل ممتاز للشخصية", "توازن درامي في الظلال", "درجة لون دافئة متناسقة"],
    issues: ["الخلفية مزدحمة قليلًا في الأعلى", "نقطة الضوء الثانوية خافتة"],
    fixes: ["أضف ضوء حافة (Rim light) خفيف", "عتّم الجزء العلوي من الخلفية"],
  },
  horror: {
    filter: "cold-horror",
    readout: {
      "قوة الإضاءة": "منخفضة جدًا مع مصدر خلفي",
      "اتجاه الضوء": "خلفي (Backlight) يصنع هالة",
      "الظلال": "كثيفة تغمر معظم الكادر",
      "درجة حرارة اللون": "باردة (≈ 5600K مع صبغة زرقاء)",
      "موضع الشخصية": "خارج المركز مع مساحة سالبة كبيرة",
      "الخلفية": "معتمة وغامضة",
      "التوازن": "غير متوازن عمدًا لخلق قلق",
      "العمق": "عمق كبير مع مناطق مظلمة",
      "الخطوط القيادية": "ممرات مظلمة تقود للعمق",
      "التكوين": "مساحة سالبة + توتر بصري",
      "التباين": "عالٍ جدًا",
      "الألوان السائدة": ["#0c1524", "#25405e", "#7fa8d0"],
    },
    recs: [
      ["حساسية الضوء ISO", "ISO 800", "لالتقاط تفاصيل في الإضاءة الخافتة جدًا", "ارفع ISO إلى 800 وراقب الضوضاء", 88],
      ["فتحة العدسة", "f/2.0", "لجمع أكبر قدر من الضوء الشحيح", "افتح العدسة بالكامل تقريبًا", 90],
      ["سرعة الغالق", "1/50", "للحفاظ على المظهر السينمائي", "اضبط الغالق على 1/50", 93],
      ["عدد الإطارات FPS", "24 FPS", "الإحساس السينمائي الكلاسيكي", "اختر 24 FPS", 95],
      ["توازن اللون الأبيض", "بارد 5600K+", "لتعزيز جو الرعب البارد", "اضبط WB نحو الأزرق", 89],
      ["نوع العدسة", "عدسة واسعة", "لزيادة الإحساس بالفراغ والوحدة", "استخدم 24mm–35mm", 82],
      ["البعد البؤري", "28mm", "لتشويه المسافة وخلق قلق", "استخدم 28mm", 80],
      ["حجم اللقطة", "لقطة واسعة", "لإبراز عزلة الشخصية", "اترك مساحة سالبة كبيرة", 86],
      ["زاوية التصوير", "زاوية هولندية اختيارية", "لخلق عدم اتزان نفسي", "أمِل الكاميرا 8°–12°", 78],
      ["حركة الكاميرا", "زحف بطيء (Slow push)", "لبناء التوتر تدريجيًا", "تقدّم ببطء شديد نحو الموضوع", 84],
      ["اتجاه الإضاءة", "خلفي مع حافة زرقاء", "لتحويل الشخصية إلى ظل", "ضع الضوء خلف الموضوع", 88],
      ["توزيع العناصر", "مساحة سالبة مهيمنة", "لتعزيز الشعور بالخطر", "ادفع الموضوع إلى حافة الكادر", 85],
      ["العمق البصري", "عمق كبير مظلم", "لإخفاء ما قد يكمن في الظلام", "حافظ على خلفية عميقة معتمة", 83],
      ["الفلتر المناسب", "رعب بارد", "يضيف صبغة زرقاء ويعمّق الظلال", "طبّق فلتر (رعب بارد) بشدة 80%", 92],
    ],
    scores: { overall: 85, composition: 88, lighting: 90, colors: 87, camera: 80 },
    strengths: ["جو بارد مرعب متماسك", "استخدام ذكي للمساحة السالبة", "تباين عالٍ فعّال"],
    issues: ["قد تفقد التفاصيل في المناطق شديدة الظلام", "الزاوية الهولندية قد تبالغ"],
    fixes: ["أضف مصدر ضوء خافت لكشف تفصيل مفتاح", "قلّل ميل الزاوية إلى 8°"],
  },
  comedy: {
    filter: "action-highcon",
    readout: {
      "قوة الإضاءة": "عالية ومتساوية (High-key)",
      "اتجاه الضوء": "أمامي ناعم واسع",
      "الظلال": "خفيفة جدًا",
      "درجة حرارة اللون": "محايدة إلى دافئة قليلًا",
      "موضع الشخصية": "قريب من المركز",
      "الخلفية": "واضحة وملوّنة وحيوية",
      "التوازن": "متوازن ومريح",
      "العمق": "عمق ميدان متوسط",
      "الخطوط القيادية": "بسيطة ومباشرة",
      "التكوين": "متمركز مع طاقة إيجابية",
      "التباين": "منخفض إلى متوسط",
      "الألوان السائدة": ["#f0b93a", "#ffd58a", "#9adfff"],
    },
    recs: [
      ["حساسية الضوء ISO", "ISO 200", "الإضاءة وفيرة فلا حاجة لرفع الحساسية", "اضبط ISO على 200", 90],
      ["فتحة العدسة", "f/4", "لإبقاء الشخصية والبيئة واضحتين", "أغلق قليلًا إلى f/4", 87],
      ["سرعة الغالق", "1/50", "إحساس سينمائي مريح", "اضبط 1/50", 92],
      ["عدد الإطارات FPS", "24 FPS", "المعدل السينمائي القياسي", "اختر 24 FPS", 94],
      ["توازن اللون الأبيض", "5000K محايد", "لألوان صادقة ومبهجة", "اضبط WB على 5000K", 88],
      ["نوع العدسة", "عدسة قياسية", "لرؤية طبيعية مريحة", "استخدم 35mm–50mm", 85],
      ["البعد البؤري", "35mm", "لاحتواء التفاعل بين الشخصيات", "استخدم 35mm", 84],
      ["حجم اللقطة", "لقطة متوسطة", "لإظهار لغة الجسد الكوميدية", "أطّر من الخصر للأعلى", 88],
      ["زاوية التصوير", "مستوى العين", "لإحساس ودّي محايد", "صوّر على مستوى العين", 90],
      ["حركة الكاميرا", "ثابتة", "لترك التوقيت الكوميدي يعمل", "استخدم حاملًا ثابتًا", 86],
      ["اتجاه الإضاءة", "أمامي ناعم", "لإضاءة مبهجة خالية من الظلال القاسية", "استخدم منتشرًا كبيرًا أماميًا", 89],
      ["توزيع العناصر", "تمركز مريح", "لبساطة بصرية تخدم الأداء", "ضع الشخصية قرب المركز", 83],
      ["العمق البصري", "طبقتان", "لعمق كافٍ دون تشتيت", "افصل الموضوع عن الخلفية قليلًا", 82],
      ["الفلتر المناسب", "أكشن عالي التباين", "يمنح ألوانًا نابضة ومبهجة", "طبّق فلترًا نابضًا بشدة 40%", 84],
    ],
    scores: { overall: 84, composition: 82, lighting: 88, colors: 86, camera: 83 },
    strengths: ["إضاءة مبهجة نظيفة", "ألوان حيوية", "وضوح جيد للأداء"],
    issues: ["التكوين متمركز أكثر من اللازم", "عمق محدود"],
    fixes: ["حرّك الشخصية إلى خط الثلث", "أضف طبقة أمامية بسيطة"],
  },
  action: {
    filter: "action-highcon",
    readout: {
      "قوة الإضاءة": "قوية واتجاهية",
      "اتجاه الضوء": "جانبي/خلفي حاد",
      "الظلال": "حادة وواضحة",
      "درجة حرارة اللون": "برتقالي/سماوي (Teal & Orange)",
      "موضع الشخصية": "ديناميكي على خط الثلث",
      "الخلفية": "حركة وضبابية اتجاهية",
      "التوازن": "ديناميكي مائل",
      "العمق": "عمق ميدان متوسط",
      "الخطوط القيادية": "أقطار حادة تقود العين",
      "التكوين": "أقطار + طاقة حركية",
      "التباين": "عالٍ جدًا",
      "الألوان السائدة": ["#ff6b3d", "#0e6a7a", "#12202c"],
    },
    recs: [
      ["حساسية الضوء ISO", "ISO 400", "توازن بين الحركة والوضوح", "اضبط ISO 400", 88],
      ["فتحة العدسة", "f/4", "لإبقاء الحركة ضمن التركيز", "استخدم f/4", 86],
      ["سرعة الغالق", "1/50 (أو 1/100 لحدة أعلى)", "1/50 للسلاسة أو أسرع لتجميد الحركة", "اختر حسب الأثر المطلوب", 84],
      ["عدد الإطارات FPS", "24 FPS (60 للحركة البطيئة)", "24 قياسي و60 للتصوير البطيء", "استخدم 60 FPS لمشاهد Slow-mo", 90],
      ["توازن اللون الأبيض", "متغير حسب المشهد", "للحفاظ على مظهر Teal & Orange", "اضبط WB ثم عدّل الفلتر", 85],
      ["نوع العدسة", "عدسة واسعة", "لإحساس بالسرعة والاندماج", "استخدم 24mm–35mm", 87],
      ["البعد البؤري", "24mm", "لتضخيم الحركة والمسافة", "استخدم 24mm", 85],
      ["حجم اللقطة", "لقطة واسعة إلى متوسطة", "لإظهار الحركة والسياق", "نوّع بين الواسعة والمتوسطة", 86],
      ["زاوية التصوير", "زوايا منخفضة ديناميكية", "لإضفاء قوة وحركة", "صوّر من الأسفل للأعلى", 83],
      ["حركة الكاميرا", "حركة يدوية/تتبع", "لنقل الطاقة والاندفاع", "استخدم Gimbal للتتبع", 88],
      ["اتجاه الإضاءة", "خلفي حاد + حافة", "لفصل الموضوع عن الفوضى", "ضع ضوءًا خلفيًا قويًا", 84],
      ["توزيع العناصر", "أقطار ديناميكية", "لخلق توتر وحركة", "استخدم خطوطًا قطرية", 85],
      ["العمق البصري", "طبقات متحركة", "لإحساس الاندماج في الحدث", "أضف عناصر أمامية متحركة", 82],
      ["الفلتر المناسب", "أكشن عالي التباين", "يعزز Teal & Orange والتباين", "طبّق الفلتر بشدة 65%", 91],
    ],
    scores: { overall: 86, composition: 87, lighting: 84, colors: 88, camera: 85 },
    strengths: ["طاقة حركية عالية", "تدرّج Teal & Orange جذاب", "تكوين قطري فعّال"],
    issues: ["قد تفقد الحدة عند 1/50", "الخلفية مشتتة أحيانًا"],
    fixes: ["ارفع الغالق لتجميد الحركة", "بسّط الخلفية أو زد الضبابية"],
  },
  romance: {
    filter: "warm-romantic",
    readout: {
      "قوة الإضاءة": "ناعمة دافئة",
      "اتجاه الضوء": "أمامي/جانبي ناعم مع Backlight ذهبي",
      "الظلال": "ناعمة ومتدرّجة",
      "درجة حرارة اللون": "دافئة جدًا (≈ 3200K)",
      "موضع الشخصية": "خط الثلث مع نظر للفراغ",
      "الخلفية": "Bokeh ذهبي ناعم",
      "التوازن": "متوازن حميمي",
      "العمق": "عمق ميدان ضحل جدًا",
      "الخطوط القيادية": "منحنيات ناعمة",
      "التكوين": "قاعدة الأثلاث + مساحة نظر",
      "التباين": "منخفض وناعم",
      "الألوان السائدة": ["#e9b06a", "#f6d9b0", "#a86b52"],
    },
    recs: [
      ["حساسية الضوء ISO", "ISO 200", "الإضاءة الناعمة كافية", "اضبط ISO 200", 88],
      ["فتحة العدسة", "f/1.8", "لـ Bokeh حالم يعزل الموضوع", "افتح العدسة إلى f/1.8", 92],
      ["سرعة الغالق", "1/50", "إحساس سينمائي ناعم", "اضبط 1/50", 90],
      ["عدد الإطارات FPS", "24 FPS", "المعدل السينمائي", "اختر 24 FPS", 93],
      ["توازن اللون الأبيض", "3200K دافئ", "لتعزيز الدفء الرومانسي", "اضبط WB على 3200K", 90],
      ["نوع العدسة", "عدسة أساسية سريعة", "لعزل وBokeh جميل", "استخدم 50mm f/1.8", 88],
      ["البعد البؤري", "85mm", "لضغط الخلفية وإطراء الوجه", "استخدم 85mm", 89],
      ["حجم اللقطة", "لقطة قريبة", "لإبراز المشاعر الحميمة", "أطّر الوجه والأكتاف", 90],
      ["زاوية التصوير", "مستوى العين", "لإحساس حميمي متساوٍ", "صوّر على مستوى العين", 87],
      ["حركة الكاميرا", "دوللي ناعم", "لحركة انسيابية رومانسية", "تحرّك ببطء وسلاسة", 85],
      ["اتجاه الإضاءة", "خلفي ذهبي + ملء ناعم", "لهالة رومانسية دافئة", "ضع Backlight ذهبيًا", 91],
      ["توزيع العناصر", "مساحة نظر أمام الوجه", "لإحساس بالتأمل والحنين", "اترك فراغًا أمام النظر", 88],
      ["العمق البصري", "خلفية ذائبة", "لعزل حالم", "اجعل الخلفية بعيدة", 86],
      ["الفلتر المناسب", "رومانسي دافئ", "يضيف دفئًا ذهبيًا ناعمًا", "طبّق (رومانسي دافئ) بشدة 60%", 92],
    ],
    scores: { overall: 87, composition: 86, lighting: 90, colors: 89, camera: 84 },
    strengths: ["دفء لوني آسر", "عزل حالم للموضوع", "إضاءة ناعمة مطرِية"],
    issues: ["التباين منخفض قد يبدو مسطحًا", "مساحة النظر غير كافية أحيانًا"],
    fixes: ["أضف لمسة تباين خفيفة", "زد الفراغ أمام اتجاه النظر"],
  },
  documentary: {
    filter: "doc-natural",
    readout: {
      "قوة الإضاءة": "طبيعية متاحة",
      "اتجاه الضوء": "حسب المصدر الطبيعي",
      "الظلال": "طبيعية غير مصطنعة",
      "درجة حرارة اللون": "محايدة صادقة",
      "موضع الشخصية": "واقعي غير متكلّف",
      "الخلفية": "بيئة حقيقية تروي السياق",
      "التوازن": "طبيعي",
      "العمق": "عمق ميدان متوسط",
      "الخطوط القيادية": "عناصر البيئة الطبيعية",
      "التكوين": "قاعدة الأثلاث الواقعية",
      "التباين": "معتدل",
      "الألوان السائدة": ["#8a8676", "#c9c3ad", "#4a5a5f"],
    },
    recs: [
      ["حساسية الضوء ISO", "ISO auto (400 مبدئيًا)", "للتكيّف مع تغيّر الضوء الطبيعي", "فعّل ISO تلقائي بحد أقصى معقول", 86],
      ["فتحة العدسة", "f/4", "عمق كافٍ لإبقاء السياق واضحًا", "استخدم f/4", 88],
      ["سرعة الغالق", "1/50", "إحساس سينمائي مع ضوء طبيعي", "اضبط 1/50", 90],
      ["عدد الإطارات FPS", "25 FPS", "شائع في الوثائقي (PAL)", "اختر 25 FPS", 87],
      ["توازن اللون الأبيض", "تلقائي/محايد", "لألوان صادقة للواقع", "استخدم WB تلقائي أو 5200K", 85],
      ["نوع العدسة", "عدسة زوم مرنة", "للتفاعل السريع مع الأحداث", "استخدم زوم 24-70mm", 84],
      ["البعد البؤري", "35mm", "رؤية طبيعية للسياق", "استخدم 35mm", 85],
      ["حجم اللقطة", "لقطة واقعية متوسطة", "لإظهار الشخص والبيئة", "أطّر الشخص مع محيطه", 86],
      ["زاوية التصوير", "مستوى العين", "للحياد والصدق", "صوّر على مستوى العين", 88],
      ["حركة الكاميرا", "ثابتة أو محمولة باليد", "الثبات للمقابلات واليد للحدث", "اختر حسب الموقف", 87],
      ["اتجاه الإضاءة", "الضوء الطبيعي المتاح", "للحفاظ على الواقعية", "استفد من نوافذ/شمس", 85],
      ["توزيع العناصر", "قاعدة الأثلاث الواقعية", "لتكوين متوازن غير متكلّف", "ضع العين على الثلث", 84],
      ["العمق البصري", "طبقتان طبيعيتان", "لإحساس بالمكان", "أظهر مقدمة وخلفية طبيعية", 82],
      ["الفلتر المناسب", "وثائقي طبيعي", "يحافظ على الألوان الصادقة", "طبّق (وثائقي طبيعي) بشدة 30%", 88],
    ],
    scores: { overall: 83, composition: 82, lighting: 80, colors: 85, camera: 86 },
    strengths: ["ألوان صادقة واقعية", "إحساس أصيل بالمكان", "مرونة في التصوير"],
    issues: ["الإضاءة الطبيعية غير متسقة", "تباين منخفض أحيانًا"],
    fixes: ["استخدم عاكسًا لملء الظلال", "راقب اتساق الضوء بين اللقطات"],
  },
  scifi: {
    filter: "scifi-neon",
    readout: {
      "قوة الإضاءة": "مصادر نيون اتجاهية",
      "اتجاه الضوء": "متعدد ملوّن + خلفي",
      "الظلال": "ملوّنة (أزرق/أرجواني)",
      "درجة حرارة اللون": "باردة مع نيون",
      "موضع الشخصية": "ضمن هندسة معمارية عميقة",
      "الخلفية": "أعماق مضيئة + ضباب جوي",
      "التوازن": "متماثل أحيانًا / ديناميكي",
      "العمق": "عمق كبير مع طبقات مضيئة",
      "الخطوط القيادية": "خطوط منظور قوية",
      "التكوين": "عمق + تباين لوني",
      "التباين": "عالٍ لوني",
      "الألوان السائدة": ["#4ea8ff", "#c46bff", "#ff5da2"],
    },
    recs: [
      ["حساسية الضوء ISO", "ISO 800", "لالتقاط النيون في بيئة معتمة", "ارفع ISO إلى 800", 88],
      ["فتحة العدسة", "f/2.8", "توازن بين الضوء والعمق", "استخدم f/2.8", 87],
      ["سرعة الغالق", "1/50", "إحساس سينمائي", "اضبط 1/50", 90],
      ["عدد الإطارات FPS", "24 FPS", "المعدل السينمائي", "اختر 24 FPS", 92],
      ["توازن اللون الأبيض", "بارد ≈ 5000K", "للحفاظ على صبغة النيون", "اضبط WB باردًا", 86],
      ["نوع العدسة", "عدسة أنامورفيك (محاكاة)", "لتوهّج أفقي سينمائي وعمق", "استخدم عدسة واسعة/أنامورفيك", 84],
      ["البعد البؤري", "35mm", "لاحتواء العمق المعماري", "استخدم 35mm", 85],
      ["حجم اللقطة", "لقطة واسعة", "لإظهار العالم الضخم", "أطّر الشخصية داخل البيئة", 87],
      ["زاوية التصوير", "منخفضة مهيبة", "لتضخيم العالم المستقبلي", "صوّر من الأسفل", 83],
      ["حركة الكاميرا", "دوللي بطيء", "لكشف العالم تدريجيًا", "تحرّك ببطء داخل الفضاء", 85],
      ["اتجاه الإضاءة", "نيون متعدد + خلفي", "لفصل الموضوع بألوان متباينة", "ضع نيونًا خلفيًا ملوّنًا", 88],
      ["توزيع العناصر", "عمق وتماثل", "لجمال بصري مستقبلي", "استخدم خطوط منظور مركزية", 86],
      ["العمق البصري", "ضباب جوي وطبقات", "لإحساس اللانهاية", "أضف ضبابًا خفيفًا", 84],
      ["الفلتر المناسب", "خيال علمي نيون", "يعزز النيون والتباين اللوني", "طبّق (خيال علمي نيون) بشدة 70%", 91],
    ],
    scores: { overall: 88, composition: 89, lighting: 87, colors: 91, camera: 84 },
    strengths: ["تباين لوني نيون آسر", "عمق بصري كبير", "جو مستقبلي متماسك"],
    issues: ["ضوضاء محتملة عند ISO 800", "قد يطغى النيون على الوجه"],
    fixes: ["أضف ملء خفيف للوجه", "قلّل ISO إن سمح الضوء"],
  },
  night: {
    filter: "night",
    readout: {
      "قوة الإضاءة": "منخفضة — مصادر عملية (Practicals)",
      "اتجاه الضوء": "من مصابيح المشهد نفسها",
      "الظلال": "طويلة وعميقة",
      "درجة حرارة اللون": "مختلطة (دافئ عملي + أزرق ليلي)",
      "موضع الشخصية": "قرب مصدر ضوء عملي",
      "الخلفية": "أضواء المدينة الغائمة (Bokeh)",
      "التوازن": "ثقل نحو مصدر الضوء",
      "العمق": "عمق كبير بأضواء متلألئة",
      "الخطوط القيادية": "انعكاسات وأضواء الشارع",
      "التكوين": "موضوع مضاء وسط ظلام",
      "التباين": "عالٍ",
      "الألوان السائدة": ["#0e1b33", "#e0a458", "#3f6fa5"],
    },
    recs: [
      ["حساسية الضوء ISO", "ISO 1600", "لالتقاط الضوء الليلي الشحيح", "ارفع ISO إلى 1600 وراقب الضوضاء", 87],
      ["فتحة العدسة", "f/1.8", "لأقصى تجميع للضوء", "افتح العدسة بالكامل تقريبًا", 90],
      ["سرعة الغالق", "1/50", "للحفاظ على السينمائية", "اضبط 1/50", 88],
      ["عدد الإطارات FPS", "24 FPS", "المعدل السينمائي", "اختر 24 FPS", 91],
      ["توازن اللون الأبيض", "≈ 3800K", "لتوازن بين العملي الدافئ والأزرق", "اضبط WB على 3800K", 85],
      ["نوع العدسة", "عدسة سريعة", "ضرورية للإضاءة المنخفضة", "استخدم f/1.4–f/1.8", 89],
      ["البعد البؤري", "35mm", "لاحتواء المشهد الليلي", "استخدم 35mm", 84],
      ["حجم اللقطة", "متوسطة إلى واسعة", "لإظهار الشخصية وأضواء المدينة", "أطّر الموضوع مع الخلفية المضيئة", 86],
      ["زاوية التصوير", "مستوى العين", "لواقعية المشهد الليلي", "صوّر على مستوى العين", 83],
      ["حركة الكاميرا", "ثابتة أو دوللي بطيء", "لإبراز جمال الأضواء", "استخدم حاملًا ثابتًا", 84],
      ["اتجاه الإضاءة", "مصادر عملية في الكادر", "لواقعية وإضاءة مبررة", "استفد من مصابيح الشارع", 88],
      ["توزيع العناصر", "موضوع مضاء وسط الظلام", "لجذب العين للموضوع", "ضع الموضوع قرب ضوء عملي", 85],
      ["العمق البصري", "أضواء خلفية متلألئة", "لعمق ليلي ساحر", "اجعل الأضواء بعيدة غير مركّزة", 87],
      ["الفلتر المناسب", "مشهد ليلي", "يعزز الزرقة الليلية والتباين", "طبّق (مشهد ليلي) بشدة 75%", 90],
    ],
    scores: { overall: 85, composition: 84, lighting: 88, colors: 86, camera: 82 },
    strengths: ["مزج جميل بين الدافئ والبارد", "Bokeh ليلي ساحر", "إضاءة عملية مبررة"],
    issues: ["ضوضاء عالية عند ISO 1600", "قد يظلم وجه الموضوع"],
    fixes: ["أضف ضوء ملء خافت للوجه", "استخدم عدسة أسرع لتقليل ISO"],
  },
};

// فلاتر الألوان السينمائية — قيم أساسية للمنزلقات
export const FILTERS = [
  { id: "dramatic-dark", name: "درامي داكن", desc: "ظلال عميقة ودفء درامي منخفض المفتاح",
    base: { exposure: -12, contrast: 32, saturation: -12, temperature: 14, shadows: -18, highlights: -6 }, swatch: "#3a2b1c" },
  { id: "warm-romantic", name: "رومانسي دافئ", desc: "دفء ذهبي ناعم وتباين منخفض حالم",
    base: { exposure: 6, contrast: 6, saturation: 18, temperature: 46, shadows: 6, highlights: 4 }, swatch: "#e9b06a" },
  { id: "cold-horror", name: "رعب بارد", desc: "صبغة زرقاء وتباين عالٍ وظلال كثيفة",
    base: { exposure: -18, contrast: 40, saturation: -22, temperature: -55, shadows: -26, highlights: -8 }, swatch: "#25405e" },
  { id: "action-highcon", name: "أكشن عالي التباين", desc: "تباين وتشبع عاليان بمظهر Teal & Orange",
    base: { exposure: 4, contrast: 52, saturation: 40, temperature: 10, shadows: -8, highlights: 6 }, swatch: "#ff6b3d" },
  { id: "doc-natural", name: "وثائقي طبيعي", desc: "ألوان صادقة واقعية بأقل تدخل",
    base: { exposure: 0, contrast: 8, saturation: 3, temperature: 0, shadows: 0, highlights: 0 }, swatch: "#c9c3ad" },
  { id: "scifi-neon", name: "خيال علمي نيون", desc: "نيون بارد وتشبع عالٍ ولمعان مستقبلي",
    base: { exposure: 5, contrast: 34, saturation: 60, temperature: -30, shadows: -12, highlights: 10 }, swatch: "#4ea8ff" },
  { id: "night", name: "مشهد ليلي", desc: "زرقة ليلية عميقة مع مصادر دافئة",
    base: { exposure: -26, contrast: 24, saturation: -6, temperature: -42, shadows: -28, highlights: -4 }, swatch: "#0e1b33" },
  { id: "bw-cinematic", name: "أبيض وأسود سينمائي", desc: "تدرّج رمادي كلاسيكي بتباين غني",
    base: { exposure: 2, contrast: 28, saturation: 0, temperature: 0, shadows: -6, highlights: 4, grayscale: 100 }, swatch: "#8a8a8a" },
];

export const FILTER_BY_ID = Object.fromEntries(FILTERS.map((f) => [f.id, f]));

// بناء سلسلة CSS filter من قيم المنزلقات
export function buildFilterCSS(a = {}) {
  const k = (a.intensity ?? 100) / 100;
  const brightness = 1 + ((a.exposure || 0) / 100 + (a.highlights || 0) / 500 + (a.shadows || 0) / 500) * k;
  const contrast = 1 + ((a.contrast || 0) / 100) * k;
  const gray = ((a.grayscale || 0) / 100) * k;
  const saturate = gray > 0.98 ? 0 : 1 + ((a.saturation || 0) / 100) * k;
  const t = ((a.temperature || 0) / 100) * k;
  let sepiaV = 0, hue = 0;
  if (t > 0) { sepiaV = t * 0.5; hue = -t * 20; }
  else if (t < 0) { sepiaV = -t * 0.45; hue = 185; }
  return `brightness(${brightness.toFixed(3)}) contrast(${contrast.toFixed(3)}) saturate(${saturate.toFixed(3)}) grayscale(${gray.toFixed(3)}) sepia(${sepiaV.toFixed(3)}) hue-rotate(${hue.toFixed(1)}deg)`;
}

export const NEUTRAL_ADJ = { exposure: 0, contrast: 0, saturation: 0, temperature: 0, shadows: 0, highlights: 0, grayscale: 0, intensity: 100 };

// قوالب أساليب الأفلام (إعدادات تعليمية مستوحاة وليست الإعدادات الأصلية للإنتاج)
export const TEMPLATES = [
  {
    id: "dune", title: "Dune – الصحراء الملحمية", filter: "warm-romantic",
    tag: "ملحمي • صحراوي", accent: "#d9a15a",
    style: "تكوينات واسعة ملحمية بألوان صحراوية دافئة وإضاءة جانبية قوية تُبرز الملمس والمقياس الهائل.",
    lighting: "إضاءة جانبية طبيعية قوية (شمس منخفضة)",
    palette: ["#d9a15a", "#c07b3e", "#e8cfa2", "#6b4a2a"],
    lens: "عدسة واسعة", focal: "24mm–35mm", angle: "منخفضة لتضخيم المقياس", shot: "لقطة واسعة جدًا (Extreme wide)",
    movement: "حركة بطيئة مهيبة",
    settings: { ISO: "200", aperture: "f/8", shutter: "1/50", fps: "24", wb: "دافئ 5000K" },
    lightPlan: "شمس جانبية منخفضة تصنع ظلالًا طويلة + عاكس خافت للملء",
    exercise: "صوّر لقطة واسعة لشخصية صغيرة داخل مشهد شاسع مع إضاءة جانبية تبرز الملمس.",
  },
  {
    id: "bladerunner", title: "Blade Runner 2049 – الخيال العلمي والنيون", filter: "scifi-neon",
    tag: "خيال علمي • نيون", accent: "#4ea8ff",
    style: "إضاءة نيون قوية وتباين لوني حاد وإضاءة خلفية وضباب جوي يخلق أعماقًا غامضة.",
    lighting: "نيون ملوّن + إضاءة خلفية + ضباب",
    palette: ["#4ea8ff", "#ff5da2", "#f0a13a", "#101826"],
    lens: "واسعة/أنامورفيك (محاكاة)", focal: "35mm", angle: "منخفضة مهيبة", shot: "لقطة واسعة عميقة",
    movement: "حركة بطيئة",
    settings: { ISO: "800", aperture: "f/2.8", shutter: "1/50", fps: "24", wb: "بارد 5000K" },
    lightPlan: "نيون خلفي ملوّن يفصل الموضوع + ضباب رقيق لتشتيت الضوء",
    exercise: "أنشئ لقطة بمصدر نيون خلفي ملوّن وضباب خفيف مع فصل واضح للموضوع عن الخلفية.",
  },
  {
    id: "budapest", title: "The Grand Budapest Hotel – التكوين المتماثل", filter: "warm-romantic",
    tag: "تماثل • باستيل", accent: "#e78fa3",
    style: "تماثل مثالي وموضوع متمركز وألوان باستيل وحركة كاميرا منضبطة وتأطير هندسي دقيق.",
    lighting: "إضاءة متساوية ناعمة (High-key)",
    palette: ["#e78fa3", "#f3d0a4", "#8ec7c1", "#b57ab0"],
    lens: "قياسية", focal: "40mm", angle: "مستوى العين مركزي", shot: "لقطة متوسطة متمركزة",
    movement: "حركات أفقية/عمودية منضبطة (Whip/Dolly)",
    settings: { ISO: "200", aperture: "f/5.6", shutter: "1/50", fps: "24", wb: "محايد 5200K" },
    lightPlan: "إضاءة أمامية متساوية بلا ظلال قاسية لإبراز التماثل والألوان",
    exercise: "كوّن لقطة متماثلة تمامًا مع موضوع متمركز في منتصف الكادر بدقة هندسية.",
  },
  {
    id: "godfather", title: "The Godfather – الدراما الكلاسيكية الداكنة", filter: "dramatic-dark",
    tag: "دراما • Low-key", accent: "#b08040",
    style: "إضاءة منخفضة المفتاح وظلال عميقة ودرجات بنية دافئة وتأطير درامي قريب مع إضاءة جزئية للوجه.",
    lighting: "منخفضة المفتاح مع إضاءة علوية جزئية",
    palette: ["#b08040", "#3a2717", "#1a120b", "#d9b46a"],
    lens: "أساسية", focal: "50mm", angle: "زاوية منخفضة طفيفة", shot: "لقطة قريبة درامية",
    movement: "ثابتة/دوللي بطيء",
    settings: { ISO: "400", aperture: "f/2.8", shutter: "1/50", fps: "24", wb: "دافئ 3400K" },
    lightPlan: "ضوء علوي رئيسي يترك العينين في ظل جزئي (Godfather lighting)",
    exercise: "أضئ نصف الوجه فقط بإضاءة علوية دافئة واترك النصف الآخر في ظل عميق.",
  },
  {
    id: "revenant", title: "The Revenant – التصوير الطبيعي", filter: "doc-natural",
    tag: "طبيعي • بارد", accent: "#7fa3a8",
    style: "ضوء طبيعي فقط وألوان باردة وعدسات واسعة وحركة واقعية وعمق بيئي واستخدام طبيعي للخلفية.",
    lighting: "ضوء نهار طبيعي فقط",
    palette: ["#7fa3a8", "#c7d0cb", "#3c4a44", "#9aa7ad"],
    lens: "واسعة", focal: "16mm–28mm", angle: "مستوى العين واقعي", shot: "واسعة إلى متوسطة",
    movement: "حركة يدوية واقعية طويلة",
    settings: { ISO: "400", aperture: "f/4", shutter: "1/50", fps: "24", wb: "بارد 6000K" },
    lightPlan: "الاعتماد الكامل على ضوء النهار + عاكس طبيعي عند الحاجة",
    exercise: "صوّر لقطة واسعة بضوء طبيعي فقط مع حركة يدوية واقعية تتبع الموضوع في بيئته.",
  },
];

export const TEMPLATE_BY_ID = Object.fromEntries(TEMPLATES.map((t) => [t.id, t]));

// تمارين التدريب العملي
export const EXERCISES = [
  { id: "drama-scene", title: "تصوير مشهد درامي", icon: "fa-masks-theater",
    goal: "إتقان الإضاءة منخفضة المفتاح والتكوين الدرامي لإبراز المشاعر.",
    instructions: "استخدم إضاءة جانبية وظلالًا متحكمًا بها مع لقطة قريبة.",
    steps: ["اختر شخصية أو موضوعًا", "ضع مصدر ضوء جانبيًا 45°", "أطّر لقطة متوسطة قريبة", "اضبط ISO 400 و f/2.8", "التقط الصورة وحلّلها"],
    checklist: ["إضاءة منخفضة المفتاح", "ظلال معبّرة", "عزل الموضوع عن الخلفية", "تكوين على خط الثلث", "درجة لون دافئة"] },
  { id: "thirds", title: "قاعدة الأثلاث", icon: "fa-table-cells",
    goal: "وضع العناصر المهمة على خطوط ونقاط الأثلاث لتكوين متوازن.",
    instructions: "فعّل شبكة الأثلاث وضع الموضوع على أحد خطوط التقاطع.",
    steps: ["فعّل شبكة الأثلاث في الكاميرا", "ضع عيون الموضوع على الخط العلوي", "اترك مساحة نظر مناسبة", "تجنّب التمركز في المنتصف", "التقط وقيّم"],
    checklist: ["الموضوع على نقطة تقاطع", "خط الأفق على ثلث", "مساحة نظر كافية", "توازن العناصر", "عدم قص أطراف مهمة"] },
  { id: "side-light", title: "إضاءة جانبية", icon: "fa-lightbulb",
    goal: "استخدام الإضاءة الجانبية لإبراز الملمس والعمق والأبعاد.",
    instructions: "ضع المصدر الرئيسي على الجانب وراقب الظلال الناتجة.",
    steps: ["ضع الضوء على 90° جانبيًا", "راقب انتقال الضوء للظل", "أضف عاكسًا خفيفًا للملء", "اضبط التعريض على الجانب المضاء", "التقط وقيّم"],
    checklist: ["اتجاه ضوء واضح", "ملمس بارز", "تدرّج ضوء إلى ظل", "عمق ثلاثي الأبعاد", "عدم فقدان تفاصيل الظل"] },
  { id: "depth", title: "العمق البصري", icon: "fa-layer-group",
    goal: "بناء طبقات أمامية ووسطى وخلفية لخلق عمق سينمائي.",
    instructions: "أضف عنصرًا أماميًا وافصل الموضوع عن خلفية بعيدة.",
    steps: ["اختر خلفية بعيدة", "أضف عنصرًا أماميًا معتمًا", "افتح العدسة f/2.8", "ركّز على الموضوع الأوسط", "التقط وقيّم العمق"],
    checklist: ["ثلاث طبقات واضحة", "فصل الموضوع عن الخلفية", "عنصر أمامي مؤطِّر", "عمق ميدان مناسب", "خطوط منظور"] },
  { id: "apply-template", title: "تطبيق أحد قوالب الأفلام", icon: "fa-clapperboard",
    goal: "إعادة إنتاج اللغة البصرية لأحد القوالب الشهيرة.",
    instructions: "اختر قالبًا وطبّق إضاءته وألوانه وتأطيره.",
    steps: ["اختر قالبًا من صفحة القوالب", "طبّق مخطط الإضاءة المقترح", "استخدم الفلتر المقترح", "اتبع حجم اللقطة والزاوية", "التقط وقارن بالمرجع"],
    checklist: ["مطابقة لوحة الألوان", "مطابقة نوع الإضاءة", "حجم لقطة صحيح", "زاوية مناسبة", "فلتر مطبّق"] },
  { id: "choose-filter", title: "اختيار الفلتر المناسب", icon: "fa-wand-magic-sparkles",
    goal: "اختيار الفلتر الذي يخدم مزاج المشهد المطلوب.",
    instructions: "حدّد مزاج المشهد ثم اختر الفلتر الأنسب واضبط شدته.",
    steps: ["حدّد نوع المشهد", "افتح صفحة الفلاتر", "طبّق الفلتر المقترح", "اضبط الشدة والتباين", "قارن قبل/بعد"],
    checklist: ["ملاءمة الفلتر للمزاج", "شدة متوازنة", "عدم فقدان التفاصيل", "درجة لون متناسقة", "تحسين واضح"] },
  { id: "camera-move", title: "حركة الكاميرا", icon: "fa-arrows-left-right",
    goal: "تنفيذ حركة كاميرا سلسة تخدم السرد.",
    instructions: "اختر نوع حركة (دوللي/تتبع) ونفّذها بثبات.",
    steps: ["اختر نوع الحركة المناسب", "خطّط لبداية ونهاية اللقطة", "حافظ على سرعة ثابتة", "أبقِ الموضوع في التكوين", "راجع سلاسة الحركة"],
    checklist: ["حركة سلسة", "سرعة ثابتة", "تكوين محفوظ", "دافع سردي للحركة", "بداية ونهاية واضحتان"] },
  { id: "balance", title: "التوازن داخل الكادر", icon: "fa-scale-balanced",
    goal: "توزيع الكتل البصرية لتحقيق توازن مريح أو توتر مقصود.",
    instructions: "وازن بين العناصر الثقيلة والفارغة في الكادر.",
    steps: ["حدّد العناصر الثقيلة بصريًا", "وازنها بمساحة سالبة", "راقب خط الأفق", "اضبط الموضع على الأثلاث", "التقط وقيّم التوازن"],
    checklist: ["توازن الكتل", "خط أفق مستقيم", "مساحة سالبة موظّفة", "توزيع على الأثلاث", "عدم ازدحام جانب واحد"] },
];

// توليد تقييم محاكاة للتمرين
export function simulateExerciseScore(checkedCount, total) {
  const ratio = total ? checkedCount / total : 0;
  const base = 55 + Math.round(ratio * 40) + Math.floor(Math.random() * 6);
  const score = Math.min(100, base);
  return {
    overall: score,
    composition: Math.min(100, score + (Math.floor(Math.random() * 10) - 4)),
    lighting: Math.min(100, score + (Math.floor(Math.random() * 10) - 5)),
    colors: Math.min(100, score + (Math.floor(Math.random() * 10) - 3)),
    camera: Math.min(100, score + (Math.floor(Math.random() * 10) - 4)),
  };
}

// جمل إرشادية للواقع المعزز
export const AR_GUIDES = [
  "حرّك الكاميرا قليلًا إلى اليمين",
  "ضع الشخصية عند نقطة التقاطع",
  "اخفض زاوية الكاميرا",
  "مصدر الضوء الرئيسي من هذا الاتجاه",
  "زد المسافة بين الشخصية والخلفية",
  "الكادر غير متوازن — أعد التوزيع",
  "اقترب للحصول على لقطة متوسطة",
  "اترك مساحة أمام اتجاه النظر",
];
